import styled from "@emotion/styled";
import { ReactNode, useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";
import { Helmet } from "react-helmet-async";
import { useAnalytics } from './useAnalytics'
import { useLocation } from "react-router-dom";

const ContentContainer = styled.div`
  margin: 0 auto;
  padding: 10pt 40pt;
  max-width: 1500px;
  @media (max-width: 899px) {
    padding: 0pt 20pt;
  }
`;

const Container = ({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) => {
  useAnalytics();
  // scroll to top when url changes
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Bhagya Perera Art - {title}</title>
        <link rel="canonical" href={process.env.REACT_APP_PUBLIC_URL + window.location.pathname} />
      </Helmet>
      <Header />
      <ContentContainer>{children}</ContentContainer>
      <Footer />
    </div>
  );
};

export default Container;
